// React Core Imports
import { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom'

// Components & Data Imports
import Navigation from './layout/Navigation'
import MainPage from './pages/MainPage'
import News from './pages/News'
import Gallery from './pages/Gallery'
import History from './pages/History'
import Contact from './pages/Contact'

// Style Imports
import './sass/main.scss'

// Auto-scroll on top when route changes
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  return (
    <Router>
      <Navigation />
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<MainPage />} />
        <Route path='*' element={<MainPage />} />
        <Route path='/aktuality' element={<News />} />
        <Route path='/galerie' element={<Gallery />} />
        <Route path='/historie' element={<History />} />
        <Route path='/kontakty' element={<Contact />} />
      </Routes>
    </Router>
  )
}

export default App
